import Vue from 'vue'
import Router from 'vue-router'
import jsBridge from '@/utils/jsBridge'
import store from './store'

Vue.use(Router);

let routes = [
    {
        meta: {title: '资讯详情'},
        path: '/information/detail',
        name: 'informationDetail',
        component: () => import( './views/information/detail.vue')
    },
    {
        meta: {title: '用户协议'},
        path: '/agreement/register',
        name: 'agreementRegister',
        component: () => import( './views/agreement/register.vue')
    },
    {
        meta: {title: '隐私政策'},
        path: '/agreement/privacy',
        name: 'agreementPrivacy',
        component: () => import( './views/agreement/privacy.vue')
    },
    {
        meta: {title: '第三方信息共享清单'},
        path: '/agreement/thirdPartyInfo',
        name: 'agreementThirdPartyInfo',
        component: () => import( './views/agreement/thirdPartyInfo.vue')
    },
    {
        meta: {title: '第三方信息共享清单'},
        path: '/agreement/coachThirdPartyInfo',
        name: 'agreementCoachThirdPartyInfo',
        component: () => import( './views/agreement/coachThirdPartyInfo.vue')
    },
    {
        meta: {title: '斑斑驾道VIP会员服务协议说明'},
        path: '/agreement/memberPartyInfo',
        name: 'agreementMemberPartyInfo',
        component: () => import( './views/agreement/memberPartyInfo.vue')
    },
    {
        meta: {title: '答题技巧'},
        path: '/answer/skill',
        name: 'answerSkill',
        component: () => import( './views/answerSkill/detail.vue')
    },
    {
        meta: {title: '驾驶技巧'},
        path: '/driving/skill',
        name: 'drivingSkill',
        component: () => import( './views/drivingSkill/detail.vue')
    },
    {
        meta: {title: '关于我们'},
        path: '/about/aboutUsTwo',
        name: 'aboutUsTwo',
        component: () => import( './views/about/aboutUsTwo.vue')
    },
    {
        meta: {title: '关于我们'},
        path: '/about/aboutUs',
        name: 'aboutUs',
        component: () => import( './views/about/aboutUs.vue')
    },

    {
        meta: {title: '考场须知'},
        path: '/instructions',
        name: 'instructions',
        component: () => import( './views/instructions/index.vue')
    },
    {
        meta: {title: '计时规则'},
        path: '/timeRule/detail',
        name: 'timeRule',
        component: () => import( './views/timeRule/detail.vue')
    },
    {
        meta: {title: '许愿池'},
        path: '/vow',
        name: 'vow',
        component: () => import( './views/vow/index.vue')
    },
    {
        meta: {title: '我的许愿'},
        path: '/myVow',
        name: 'myVow',
        component: () => import( './views/vow/myVow.vue')
    },
    {
        meta: {title: '许愿池'},
        path: '/vow/404',
        name: 'vowClose',
        component: () => import( './views/vow/404.vue')
    },
    {
        meta: {title: '报名资料'},
        path: '/registerData',
        name: 'registerData',
        component: () => import( './views/registerData/index.vue')
    },
    {
        meta: {title: '入学欢迎'},
        path: '/welcome/detail',
        name: 'welcomeDetail',
        component: () => import( './views/welcome/detail.vue')
    },
    {
        meta: {title: '练车意向'},
        path: '/intention/detail',
        name: 'intentionDetail',
        component: () => import( './views/intention/detail.vue')
    },
    {
        meta: {title: '体检流程'},
        path: '/physical/detail',
        name: 'physicalDetail',
        component: () => import( './views/physical/detail.vue')
    },
    {
        meta: {title: '下载'},
        path: '/bb/direct/down',
        name: 'down',
        component: () => import( './views/down/index.vue')
    },
    {
        meta: {title: '下载'},
        path: '/bb/down',
        name: 'bbDown',
        component: () => import( './views/bb/down.vue')
    },
    {
        meta: {title: '下载'},
        path: '/sh/down',
        name: 'shDown',
        component: () => import( './views/shDown/index.vue')
    },
    {
        meta: {title: '教练端下载'},
        path: '/coach/down',
        name: 'coachDown',
        component: () => import( './views/coach/down.vue')
    },
    {
        meta: {title: '活动详情'},
        path: '/classInformation/index',
        name: 'classInformation',
        component: () => import( './views/classInformation/index.vue')
    },
    {
        meta: {title: '考试费网上缴纳操作指引'},
        path: '/direction',
        name: 'direction',
        component: () => import( './views/direction/index.vue')
    },
    {
        meta: {title: '问题详情'},
        path: '/problem',
        name: 'problem',
        component: () => import( './views/problem/index.vue')
    },
    {
        meta: {title: '计时认证'},
        path: '/timeAuth',
        name: 'timeAuth',
        component: () => import( './views/timeAuth/index.vue')
    },
    {
        meta: {title: '计时认证详情',},
        path: '/timeAuthDetail',
        name: 'timeAuthDetail',
        component: () => import( './views/timeAuth/detail.vue')
    },
    {
        meta: {title: '计时认证详情',},
        path: '/coachTimeAuthDetail',
        name: 'coachTimeAuthDetail',
        component: () => import( './views/coachTime/detail.vue')
    },
    {
        meta: {title: '计时规则'},
        path: '/timingRulesDes',
        name: 'timingRulesDes',
        component: () => import( './views/timingRulesDes/index.vue')
    },
    {
        meta: {title: '身份验证'},
        path: '/timeAuthFaceTips',
        name: 'timeAuthFaceTips',
        component: () => import( './views/timeAuth/faceTips.vue')
    },
    {
        meta: {title: '上榜有奖'},
        path: '/ontheList',
        name: 'ontheList',
        component: () => import( './views/prize/ontheList.vue')
    },
    {
        meta: {title: '用户情书'},
        path: '/userslovelLetter',
        name: 'userslovelLetter',
        component: () => import( './views/prize/userslovelLetter.vue')
    },
    {
        meta: {title: '计时认证'},
        path: '/timePay',
        name: 'timePay',
        component: () => import( './views/timePay/index.vue')
    },
    {
        meta: {title: '计时认证'},
        path: '/timePaySecond',
        name: 'timePaySecond',
        component: () => import( './views/timePaySecond/index.vue')
    },
    {
        meta: {title: '斑斑驾道计时认证'},
        path: '/timePayThree',
        name: 'timePayThree',
        component: () => import( './views/timePayThree/index.vue')
    },
    {
        meta: {title: '斑斑驾道计时认证'},
        path: '/timePayThreeV2',
        name: 'timePayThreeV2',
        component: () => import( './views/timePayThreeV2/index.vue')
    },
    {
        meta: {title: '计时认证'},
        path: '/timePayLN',
        name: 'timePayLN',
        component: () => import( './views/timePayLN/index.vue')
    },
    {
        meta: {title: '开通指引'},
        path: '/timeGuide',
        name: 'timeGuide',
        component: () => import( './views/timeAuth/guide.vue')
    },
    {
        meta: {title: '开通计时功能'},
        path: '/timeAppPay',
        name: 'timeAppPay',
        component: () => import( './views/timeAuth/pay.vue')
    },
    {
        meta: {title: '计时卡服务协议'},
        path: '/timeAppPayAg',
        name: 'timeAppPayAg',
        component: () => import( './views/timeAuth/agreement.vue')
    },
    {
        meta: {title: '视频详情'},
        path: '/videoDetail',
        name: 'videoDetail',
        component: () => import( './views/video/detail.vue')
    },
    {
        meta: {title: '视频详情'},
        path: '/coachVideoDetail',
        name: 'coachVideoDetail',
        component: () => import( './views/video/coachVideoDetail.vue')
    },
    {
        meta: {title: '学车报告'},
        path: '/studyReport',
        name: 'studyReport',
        component: () => import( './views/report/index.vue')
    },
    {
        meta: {title: '排行榜'},
        path: '/rank',
        name: 'rank',
        component: () => import( './views/rank/index.vue')
    },{
        meta: {title: '排行榜'},
        path: '/coachRank',
        name: 'coachRank',
        component: () => import( './views/rank/coach.vue')
    },
    {
        meta: {title: '分享'},
        path: '/bb/index',
        name: 'bbIndexShare',
        component: () => import( './views/share/bb')
    },
    {
        meta: {title: '分享'},
        path: '/bbjd/index',
        name: 'bbjdIndexShare',
        component: () => import( './views/share/bb')
    },
    {
        meta: {title: '大转盘'},
        path: '/lottery',
        name: 'lottery',
        component: () => import( './views/lottery/lottery')
    },
    {
        meta: {title: '大转盘分享'},
        path: '/shareLottery',
        name: 'shareLottery',
        component: () => import( './views/lottery/lottery')
    },
    {
        meta: {title: '智能教练'},
        path: '/robot',
        name: 'robot',
        component: () => import( './views/robot/index')
    },
    {
        meta: {title: '学车流程'},
        path: '/learningProcess',
        name: 'learningProcess',
        component: () => import( './views/learningProcess/index')
    },
    {
        meta: {title: '学车流程'},
        path: '/learningProcessV2',
        name: 'learningProcessV2',
        component: () => import( './views/learningProcess/indexV2')
    },
    {
        meta: {title: '接送地点选择'},
        path: '/appLocation',
        name: 'appLocation',
        component: () => import( './views/appLocation/index')
    },
    {
        meta: {title: '新国标红绿灯'},
        path: '/newTrafficLights',
        name: 'newTrafficLights',
        component: () => import( './views/newTrafficLights/index')
    },
    {
        meta: {title: ''},
        path: '/exerciseBookPage',
        name: 'exerciseBookPage',
        component: () => import( './views/exerciseBookPage/index')
    },
    {
        meta: {title: '登录'},
        path: '/coachLogin',
        name: 'coachLogin',
        component: () => import( './views/coachLogin/index')
    },
    {
        meta: {title: '阶段学时上报'},
        path: '/jiangxi',
        name: 'jiangxi',
        component: () => import( './views/jiangxi/index')
    },
    {
        meta: {title: '计时认证'},
        path: '/coachTimeAuth',
        name: 'coachTimeAuth',
        component: () => import( './views/coachTime/auth')
    },
    {
        meta: {title: '教练员-计时认证'},
        path: '/timePayCoach',
        name: 'timePayCoach',
        component: () => import( './views/timePayCoach/index')
    },
    {
        meta: {title: '视频详情'},
        path: '/wxTImeVideo',
        name: 'wxTImeVideo',
        component: () => import( './views/wxTimeVideo/index')
    },
    {
        meta: {title: '计时课程考试'},
        path: '/exam/home',
        name: 'examHome',
        component: () => import( './views/exam/index')
    },
    {
        meta: {title: '考试记录'},
        path: '/exam/record',
        name: 'examRecord',
        component: () => import( './views/exam/record')
    },
    {
        meta: {title: '计时考试'},
        path: '/exam/answer',
        name: 'examAnswer',
        component: () => import( './views/exam/answer')
    },
    {
        meta: {title: '培训证书'},
        path: '/exam/cert',
        name: 'examCert',
        component: () => import( './views/exam/cert')
    },
    {
        meta: {title: '岗前培训考试'},
        path: '/examTraining/home',
        name: 'examTrainingHome',
        component: () => import( './views/examTraining/index')
    },
    {
        meta: {title: '考试记录'},
        path: '/examTraining/record',
        name: 'examTrainingRecord',
        component: () => import( './views/examTraining/record')
    },
    {
        meta: {title: '计时考试'},
        path: '/examTraining/answer',
        name: 'examTrainingAnswer',
        component: () => import( './views/examTraining/answer')
    },
    {
        meta: {title: '培训证书'},
        path: '/examTraining/cert',
        name: 'examTrainingCert',
        component: () => import( './views/examTraining/cert')
    },
    {
        meta: {title: '计时认证'},
        path: '/examTraining/auth',
        name: 'examTrainingAuth',
        component: () => import( './views/examTraining/auth')
    },
    {
        meta: {title: '计时认证详情'},
        path: '/examTraining/authDetail',
        name: 'examTrainingAuthDetail',
        component: () => import( './views/examTraining/authDetail')
    },
    {
      meta: { title: '选接送点' }, // 斑斑驾道
      path: '/bbjd/selectRoute',
      name: 'selectRoute',
      component: () => import('./views/bbjd/selectRoute')
    },
    {
      meta: { title: '预约学车' }, // 斑斑驾道
      path: '/bbjd/appointmentCar',
      name: 'appointmentCar',
      component: () => import('./views/bbjd/appointmentCar/index.vue')
    },
    {
      meta: { title: '学车记录' }, // 斑斑驾道
      path: '/bbjd/trainingRecord',
      name: 'trainingRecord',
      component: () => import('./views/bbjd/trainingRecord')
    },
    {
      meta: { title: '教学日志' }, // 斑斑驾道
      path: '/bbjd/teachingLog',
      name: 'teachingLog',
      component: () => import('./views/bbjd/teachingLog')
    },
    {
      meta: { title: '接送记录' }, // 斑斑驾道
      path: '/bbjd/appointmentCarRecord',
      name: 'appointmentCarRecord',
      component: () => import('./views/bbjd/appointmentCarRecord')
    },
    {
        meta: { title: '预约查询' },
        path: '/coachSchedule/query',
        name: 'coachScheduleQuery',
        component: () => import('./views/coachSchedule/query')
    },
    {
        meta: { title: '关闭排班' },
        path: '/coachSchedule/closeRostering',
        name: 'coachScheduleCloseRostering',
        component: () => import('./views/coachSchedule/closeRostering')
    },
    {
        meta: { title: '教学日志' },
        path: '/coachSchedule/teachingLog',
        name: 'coachScheduleTeachingLog',
        component: () => import('./views/coachSchedule/teachingLog')
    },
    {
        meta: { title: '排班计划' },
        path: '/coachSchedule/workRule',
        name: 'coachScheduleWorkRule',
        component: () => import('./views/coachSchedule/workRule')
    },
    {
        meta: { title: '学员接送' },
        path: '/coachSchedule/studentTransfer',
        name: 'coachScheduleStudentTransfer',
        component: () => import('./views/coachSchedule/studentTransfer')
    },
    {
        meta: { title: '满分教育' },
        path: '/threeForces/fullScoreEducation',
        name: 'threeForcesFullScoreEducation',
        component: () => import('./views/threeForces/fullScoreEducation')
    },
    {
        meta: { title: '学法减分' },
        path: '/threeForces/learnRuleHome',
        name: 'threeForcesLearnRuleHome',
        component: () => import('./views/threeForces/learnRuleHome')
    },
    {
        meta: { title: '三力测试' },
        path: '/threeForces/threeAbilitiesTest',
        name: 'threeForcesThreeAbilitiesTest',
        component: () => import('./views/threeForces/threeAbilitiesTest')
    },
    {
        meta: { title: '预录订单列表' },
        path: '/preRepairOrder',
        name: 'preRepairOrder',
        component: () => import('./views/preRepairOrder/router'),
        children: [
            {
                meta: { title: '预录订单列表', cache: true },
                path: 'list',
                name: 'preRepairOrderList',
                component: () => import('./views/preRepairOrder/list')
            },
            {
                meta: { title: '预录订单详情' },
                path: 'detail',
                name: 'preRepairOrderDetail',
                component: () => import('./views/preRepairOrder/detail')
            },
            {
                meta: { title: '预览合同' },
                path: 'preview',
                name: 'preRepairOrderPreview',
                component: () => import('./views/preRepairOrder/preview')
            },
            {
                meta: { title: '新增预录订单' },
                path: 'modify',
                name: 'preRepairOrderModify',
                component: () => import('./views/preRepairOrder/modify')
            },
        ]
    },
    {
        meta: { title: '学车合同管理系统' },
        path: '/preRepairOrderGzh/index',
        name: 'preRepairOrderGzhIndex',
        component: () => import('./views/preRepairOrderGzh')
    },
    {
        meta: { title: '学车合同管理系统' },
        path: '/redirect',
        name: 'redirect',
        component: () => import('./views/redirect/index')
    },
    {
        meta: { title: '荣誉证书' },
        path: '/certificate/generate',
        name: 'generateCertificate',
        component: () => import('./views/businessCard/certificate')
    },
    {
        meta: { title: '发布活动' },
        path: '/activity/publish',
        name: 'publishActivity',
        component: () => import('./views/businessCard/publish')
    },
    {
        meta: { title: '活动规则' },
        path: '/activity/rule',
        name: 'activityRule',
        component: () => import('./views/businessCard/rule')
    },
    {
        meta: { title: '' },
        path: '/shortVideoShare',
        name: 'shortVideoShare',
        component: () => import('./views/shortVideoShare/index')
    },
    {
        meta: {title: '教练员岗前培训'},
        path: '/examTraining/pay',
        name: 'examTrainingPay',
        component: () => import( './views/examTraining/pay')
    },
    {
        meta: {title: '计时卡服务协议'},
        path: '/examTraining/ag',
        name: 'examTrainingAg',
        component: () => import( './views/examTraining/agreement')
    },
    {
        meta: {title: '教练员再教育培训'},
        path: '/coachTime/pay',
        name: 'coachTimePay',
        component: () => import( './views/coachTime/pay')
    },
    {
        meta: {title: '计时卡服务协议'},
        path: '/coachTime/ag',
        name: 'coachTimeAg',
        component: () => import( './views/coachTime/agreement')
    },
    {
        meta: {title: '线下学时'},
        path: '/offlineHours',
        name: 'offlineHours',
        component: () => import( './views/offlineHours/index.vue')
    },
];

const router = new Router({
    base: "/ui/h5/",
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {

        document.title = to.meta.title

        if(!(['answerSkill','drivingSkill'].includes(to.name))){
            jsBridge.callBackHandler('changeTitle', { title: to.meta.title })
        }
    }
    // 路由中 使用了catch 进入这个页面将缓存下来
    if (to.meta && to.meta.cache) {
        store.dispatch('addKeepIncludes', to.name)
    }
    // 进入目标页面的时候 如果携带了参数 将 移除目标页面的缓存
    if (to.params && to.params.noCache === true) {
        store.dispatch('removeKeepIncludes', to.name)
    }
    next()
});

export default router

